const NAMESPACE = 'gettingStarted/builds';

export const BUILDS_GET = `${NAMESPACE}/BUILDS_GET`;
